import { KeyFilterPattern } from 'primeng/keyfilter';
import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export type InputIconPos = 'left' | 'right';

export type InputType =
  | 'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week';

export interface IEoInputConfig extends IEoFormControlConfig {
  type?: InputType;
  inputIcon?: string;
  inputIconPos?: InputIconPos;
  pKeyFilter?: RegExp | KeyFilterPattern | null;
  inputStyleClass?: string;
  placeholder?: string;
  numMode?:string;
  minFractionDigits?:string;
}

export class EoInputConfig extends EoFormControlConfig implements IEoInputConfig {
  override type?: InputType;
  inputIcon?: string;
  inputIconPos?: InputIconPos;
  pKeyFilter?: RegExp | KeyFilterPattern | null;
  inputStyleClass?: string;
  placeholder?: string;
  numMode?:string;
  minFractionDigits?:string;

  constructor();
  constructor(obj: IEoInputConfig);
  constructor(obj?: IEoInputConfig) {
    super(obj as IEoFormControlConfig);
    this.type = obj?.type ?? 'text';
    this.inputIcon = obj?.inputIcon;
    this.inputIconPos = obj?.inputIconPos;
    this.pKeyFilter = obj?.pKeyFilter;
    this.inputStyleClass = obj?.inputStyleClass;
    this.placeholder = obj?.placeholder;
    this.numMode = obj?.numMode;
    this.minFractionDigits = obj?.minFractionDigits;
  }
}
